import { GroupBase, OptionsOrGroups } from 'react-select/dist/declarations/src/types';
import { useMemo } from 'react';
import debounce from 'debounce-promise';

type LoadOptions<Option, Group extends GroupBase<Option>> =
  | ((inputValue: string, callback: (options: OptionsOrGroups<Option, Group>) => void) => void)
  | ((inputValue: string) => Promise<OptionsOrGroups<Option, Group>>);

export const DEFAULT_DEBOUNCE_IN_MS = 300;

export const useDebounceLoadOptions = <Option, Group extends GroupBase<Option>>(
  loadOptions: LoadOptions<Option, Group>,
  debounceInMs: number = DEFAULT_DEBOUNCE_IN_MS
): LoadOptions<Option, Group> => useMemo(() => debounce(loadOptions, debounceInMs), [debounceInMs]);

export { createFilter } from 'react-select';
